<template>
<div
  class="dropup"
>
  <div
    class="bulk_action dropdown-toggle"
    id="dropdownMenuButton"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    
  v-if="selectedDspList && selectedDspList.length>0"
  >
    <span class="text">Bulk Actions</span>
  </div>
    <div class="form-row">
      <div
        class="dropdown-menu remove-style"
        aria-labelledby="dropdownMenuButton"
      >
        <a
          style="cursor: pointer"
          class="dropdown-item"
          :disabled="selectedDspList.length < 1"
          @click="
            selectedBulkAction = 'Add tags to orders';
            selectAction();
          "
        >
          Add tags to orders
        </a>
      </div>
    <div><TagDsp ref="tagsPopup" @closeModal="closeModal" /></div>
    </div>
  </div>
</template>

<script>
import TagDsp from "./TagDsp.vue";
import DeletePopUp from "../delete/DeletePopUp.vue";

export default {
  name: "CampaignActions",
  components: {
    TagDsp,
    DeletePopUp,
  },
  data() {
    return {
      selectedBulkAction: "Action",
      isOpenDeleteModal: false,
    };
  },
  computed: {
    selectedDspList: {
      get() {
        return this.$store.state.selectedBulkDsp;
      },
      set(val) {
        this.$store.state.selectedBulkDsp = val;
      },
    },
 
    actionSelectionControl: {
      set(val) {
        this.$store.state.campaign.actionSelectionControl = val;
      },
      get() {
        return this.$store.state.campaign.actionSelectionControl;
      },
    },
  },
  mounted() {},
  methods: {
    selectAction() {
      if (this.selectedBulkAction == "Add tags to orders") {
				this.$refs["tagsPopup"].getTagsList();
        $("#taggable").modal("show");
      }
    },
    closeModal() {
      $("#taggable").modal("hide");
      this.$store.state.campaign.campaignToAddToGroupList = [];
      this.actionSelectionControl = false;
      this.selectedBulkAction = "Action";
    },

  },
};
</script>

<style lang="scss">
</style>
